// extracted by mini-css-extract-plugin
export var cardContainer = "_nz-0";
export var cardHeader = "_nz-2";
export var collapsedState = "_nz-3";
export var dragHandle = "_nz-5";
export var dragHandleIcon = "_nz-6";
export var dragging = "_nz-1";
export var titleArea = "_nz-4";